import { GridColDef } from "@mui/x-data-grid-pro";
import { DefaultCheckBox } from "../../../../../../common/components/default_checkbox";

/**
 * GenerateColumnsDefinition
 */

type Props = {
  onDesabilitarCriacaoChange: (idTela: string, newValue: boolean) => void;
  onDesabilitarExclusaoChange: (idTela: string, newValue: boolean) => void;
  onDesabilitarEdicaoChange: (idTela: string, newValue: boolean) => void;
  onDesabilitarRelatorioChange: (idTela: string, newValue: boolean) => void;
  onDesabilitarAlteracaoStatusChange: (idTela: string, newValue: boolean) => void;
  onDesabilitarExclusaoDocChange: (idTela: string, newValue: boolean) => void;
  onDesabilitarExclusaoLoteChange: (idTela: string, newValue: boolean) => void;
  onDesabilitarAprovacaoLoteChange: (idTela: string, newValue: boolean) => void;

};

export const GenerateColumnsDefinition = ({
  onDesabilitarCriacaoChange,
  onDesabilitarExclusaoChange,
  onDesabilitarEdicaoChange,
  onDesabilitarRelatorioChange,
  onDesabilitarAlteracaoStatusChange,
  onDesabilitarExclusaoDocChange,
  onDesabilitarExclusaoLoteChange,
  onDesabilitarAprovacaoLoteChange,

}: Props): GridColDef[] => {
  return [
    {
      field: "desabilitaCriacao",
      filterable: false,
      headerName: "Desabilitar Criação",
      minWidth: 90,
      width: 90,
      sortable: false,
      headerClassName: 'bg-blue-50',
      cellClassName: 'bg-blue-50',
      renderHeader: () => (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2', textAlign: 'initial' }}>
          Desabilitar<br />Criação
        </div>
      ),
      valueGetter: (_, row) => ({
        desabilitaCriacao: row['desabilitaCriacao'] as boolean,
        criacao: row['criacao'] as boolean,
        idTela: row['id'] as string
      }),
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          {value.desabilitaCriacao === true && (
            <DefaultCheckBox
              name='desabilitaCriacao'
              label=''
              value={value.criacao}
              readonly={false}
              onChangeValue={(newValue) => onDesabilitarCriacaoChange(value.idTela, newValue)}
            />
          )}
        </div>
      )
    },
    {
      field: "desabilitaExclusao",
      filterable: false,
      headerName: "Desabilitar Exclusão",
      minWidth: 90,
      width: 90,
      sortable: false,
      headerClassName: 'bg-red-50',
      cellClassName: 'bg-red-50',
      renderHeader: () => (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2', textAlign: 'center' }}>
          Desabilitar<br />Exclusão
        </div>
      ),
      valueGetter: (_, row) => ({
        desabilitaExclusao: row['desabilitaExclusao'] as boolean,
        exclusao: row['excluir'] as boolean,
        idTela: row['id'] as string
      }),
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          {value.desabilitaExclusao === true && (
            <DefaultCheckBox
              name='desabilitaExclusao'
              label=''
              value={value.exclusao}
              readonly={false}
              onChangeValue={(newValue) => onDesabilitarExclusaoChange(value.idTela, newValue)}
            />
          )}
        </div>
      )
    },
    {
      field: "desabilitaEdicao",
      filterable: false,
      headerName: "Desabilitar Edição",
      minWidth: 90,
      width: 90,
      sortable: false,
      headerClassName: 'bg-green-50',
      cellClassName: 'bg-green-50',
      renderHeader: () => (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2', textAlign: 'center' }}>
          Desabilitar<br />Edição
        </div>
      ),
      valueGetter: (_, row) => ({
        desabilitaEdicao: row['desabilitaEdicao'] as boolean,
        edicao: row['editar'] as boolean,
        idTela: row['id'] as string
      }),
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          {value.desabilitaEdicao === true && (
            <DefaultCheckBox
              name='desabilitaEdicao'
              label=''
              value={value.edicao}
              readonly={false}
              onChangeValue={(newValue) => onDesabilitarEdicaoChange(value.idTela, newValue)}
            />
          )}
        </div>
      )
    },
    {
      field: "desabilitaRelatorio",
      filterable: false,
      headerName: "Desabilitar Relatório",
      minWidth: 90,
      width: 90,
      sortable: false,
      headerClassName: 'bg-yellow-50',
      cellClassName: 'bg-yellow-50',
      renderHeader: () => (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2', textAlign: 'center' }}>
          Desabilitar<br />Relatório
        </div>
      ),
      valueGetter: (_, row) => ({
        desabilitaRelatorio: row['desabilitaRelatorio'] as boolean,
        relatorio: row['relatorio'] as boolean,
        idTela: row['id'] as string
      }),
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          {value.desabilitaRelatorio === true && (
            <DefaultCheckBox
              name='desabilitaRelatorio'
              label=''
              value={value.relatorio}
              readonly={false}
              onChangeValue={(newValue) => onDesabilitarRelatorioChange(value.idTela, newValue)}
            />
          )}
        </div>
      )
    },
    {
      field: "desabilitaStatus",
      filterable: false,
      headerName: "Desabilitar Alteração de Status",
      minWidth: 90,
      width: 90,
      sortable: false,
      headerClassName: 'bg-blue-50',
      cellClassName: 'bg-blue-50',
      renderHeader: () => (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2', textAlign: 'center' }}>
          Desabilitar<br />Alteração <br /> de Status
        </div>
      ),
      valueGetter: (_, row) => ({
        desabilitaStatus: row['desabilitaStatus'] as boolean,
        status: row['status'] as boolean,
        idTela: row['id'] as string
      }),
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          {value.desabilitaStatus === true && (
            <DefaultCheckBox
              name='desabilitaStatus'
              label=''
              value={value.status}
              readonly={false}
              onChangeValue={(newValue) => onDesabilitarAlteracaoStatusChange(value.idTela, newValue)}
            />
          )}
        </div>
      )
    },
    {
      field: "desabilitaExclusaoDoc",
      filterable: false,
      headerName: "Desabilitar Exclusão Doc",
      minWidth: 90,
      width: 90,
      sortable: false,
      headerClassName: 'bg-red-50',
      cellClassName: 'bg-red-50',
      renderHeader: () => (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2', textAlign: 'center' }}>
          Desabilitar<br />Exclusão Doc
        </div>
      ),
      valueGetter: (_, row) => ({
        desabilitaExclusaoDoc: row['desabilitaExclusaoDoc'] as boolean,
        exclusaoDoc: row['excluirDoc'] as boolean,
        idTela: row['id'] as string
      }),
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          {value.desabilitaExclusaoDoc === true && (
            <DefaultCheckBox
              name='desabilitaExclusaoDoc'
              label=''
              value={value.exclusaoDoc}
              readonly={false}
              onChangeValue={(newValue) => onDesabilitarExclusaoDocChange(value.idTela, newValue)}
            />
          )}
        </div>
      )
    },
    {
      field: "desabilitaAprovacaoLote",
      filterable: false,
      headerName: "Desabilitar Aprovação Lote",
      minWidth: 90,
      width: 90,
      sortable: false,
      headerClassName: 'bg-green-50',
      cellClassName: 'bg-green-50',
      renderHeader: () => (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2', textAlign: 'center' }}>
          Desabilitar<br />Aprovação Lote
        </div>
      ),
      valueGetter: (_, row) => ({
        desabilitaAprovacaoLote: row['desabilitaAprovacaoLote'] as boolean,
        aprovacaoLote: row['aprovarLote'] as boolean,
        idTela: row['id'] as string
      }),
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          {value.desabilitaAprovacaoLote === true && (
            <DefaultCheckBox
              name='desabilitaAprovacaoLote'
              label=''
              value={value.aprovacaoLote}
              readonly={false}
              onChangeValue={(newValue) => onDesabilitarAprovacaoLoteChange(value.idTela, newValue)}
            />
          )}
        </div>
      )
    },
    {
      field: "desabilitaExclusaoLote",
      filterable: false,
      headerName: "Desabilitar Exclusão Lote",
      minWidth: 90,
      width: 90,
      sortable: false,
      headerClassName: 'bg-yellow-50',
      cellClassName: 'bg-yellow-50',
      renderHeader: () => (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.2', textAlign: 'center' }}>
          Desabilitar<br />Exclusão Lote
        </div>
      ),
      valueGetter: (_, row) => ({
        desabilitaExclusaoLote: row['desabilitaExclusaoLote'] as boolean,
        exclusaoLote: row['excluirLote'] as boolean,
        idTela: row['id'] as string
      }),
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          {value.desabilitaExclusaoLote === true && (
            <DefaultCheckBox
              name='desabilitaExclusaoLote'
              label=''
              value={value.exclusaoLote}
              readonly={false}
              onChangeValue={(newValue) => onDesabilitarExclusaoLoteChange(value.idTela, newValue)}
            />
          )}
        </div>
      )
    },


  ];
}